module.exports = __webpack_public_path__ + "static/media/mentor-matcher-premium-no-bg.32fd74fc.svg";